var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarredClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 8.02166 2 5.78249 3.39124 4.39124C4.78249 3 7.02166 3 11.5 3C15.9783 3 18.2175 3 19.6088 4.39124C21 5.78249 21 8.02166 21 12.5C21 16.9783 21 19.2175 19.6088 20.6088C18.2175 22 15.9783 22 11.5 22C7.02166 22 4.78249 22 3.39124 20.6088C2 19.2175 2 16.9783 2 12.5Z",
    fill: "#F6A723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3638 8.22209L13.2437 9.99644C13.3637 10.2434 13.6837 10.4804 13.9536 10.5257L15.5485 10.7929C16.5684 10.9643 16.8083 11.7103 16.0734 12.4462L14.8335 13.6964C14.6236 13.9081 14.5086 14.3164 14.5736 14.6087L14.9285 16.1562C15.2085 17.3812 14.5636 17.855 13.4887 17.2148L11.9939 16.3226C11.7239 16.1613 11.2789 16.1613 11.004 16.3226L9.50913 17.2148C8.43925 17.855 7.78932 17.3761 8.06929 16.1562L8.42425 14.6087C8.48925 14.3164 8.37426 13.9081 8.16428 13.6964L6.92442 12.4462C6.1945 11.7103 6.42947 10.9643 7.44936 10.7929L9.04419 10.5257C9.30916 10.4804 9.62912 10.2434 9.74911 9.99644L10.629 8.22209C11.109 7.2593 11.8889 7.2593 12.3638 8.22209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredClicked);
export default __webpack_public_path__ + "static/media/starred-clicked.700aa2f9ff63d3a55cb0af999fab17d9.svg";
export { ForwardRef as ReactComponent };